import React, { useEffect, useState } from 'react'
import { injectIntl } from 'react-intl'
import { styled } from '@mui/styles'
import './styles.css'
import { Button, Grid, Tooltip } from '@mui/material'
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined'

const StyledButton = styled(Button)(({ theme }) => ({
  '&.MuiButton-root': {
    minWidth: 0,
  },
  '& .MuiButton-startIcon': {
    marginRight: 0,
    marginLeft: 0,
  },
}))

// Abre o MESMO drawer de histórico do solicitante usado na tela de edição de chamado
// (RequesterHistorySidePanel), com o histórico geral do solicitante do chat (inclui chamados).
function ChatHeaderRequesterHistorybar(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 599.9)

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 599.9)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (<div style={{ paddingRight: 10 }}>
    <Grid container spacing={0} >
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="omnichannel-chat-header-user-action-bar-info-button-container" >
        <Tooltip title="Histórico Solicitante" arrow>
          <StyledButton
            style={{
              border: '1px solid rgba(0, 0, 0, .4)',
              backgroundColor: 'transparent',
              color: 'black',
              textTransform: 'none'
            }}
            variant="outlined"
            onClick={() => props.openRequesterHistorySidePanel && props.openRequesterHistorySidePanel()}
            startIcon={<AssignmentIndOutlinedIcon sx={{ color: '#000' }} />} >
          </StyledButton>
        </Tooltip>
      </Grid>
    </Grid>
  </div>)
}

export default injectIntl(ChatHeaderRequesterHistorybar)
